/* eslint-disable */
import { observable, action, computed } from 'mobx';
import { FormStore } from 'libs/forms/app';

import { goBack } from 'core/routing';

// FIXME - review this file

export class WizardStore {
  formStores = new Map();

  @observable activeFormName = '';

  @observable completedForms = [];

  @observable flow = [];

  @computed get activeForm() {
    return this.formStores.get(this.activeFormName);
  }

  constructor(target, conf, wizardName, handlers = {}) {
    this.handlers = handlers;
    for (const [index, formName] of conf[wizardName].entries()) {
      this.formStores.set(formName, new FormStore(target, conf, formName, {}));
      if (index === 0) {
        this.SetInitialForm(formName);
      }
    }
  }

  @action clearDraft = () => {
    this.formStores.forEach(form => {
      form.clearDraft();
    });
  };

  @action ToErrorForm = errs => {
    const errsObj = {};
    for (const err of errs) {
      errsObj[err.key] = err;
    }
    const errKeys = Object.keys(errsObj);
    let backTo = null;
    for (const [formName, formStore] of this.formStores.entries()) {
      for (const [fieldKey, fieldStore] of formStore.fieldStores.entries()) {
        if (errKeys.includes(fieldKey)) {
          if (backTo === null) {
            backTo = formName;
          }
          fieldStore.SetServerValidation(errsObj[fieldKey]);
        }
      }
    }
    if (backTo !== null) {
      this.BackTo(backTo);
      this.activeForm.alert();
    }
  };

  @action SetInitialForm = formName => {
    this.activeFormName = formName;
  };

  @action SetActiveFormName = formName => {
    if (this.formStores.get(this.activeFormName).isValid) {
      this.completedForms.push(this.activeFormName);
      this.activeFormName = formName;
    } else {
      this.formStores.get(this.activeFormName).alert();
    }
  };

  @action BackTo = formName => {
    while (
      formName !== this.activeFormName &&
      this.completedForms.length !== 0
    ) {
      this.Back();
    }
  };

  @computed get currentFlowStep() {
    if (!this.flow || this.flow.length === 0) return 0;
    return (
      this.flow.findIndex(formName => formName === this.activeFormName) + 1
    );
  }

  @computed get flowSteps() {
    return this.flow.length;
  }

  @action Back = (window) => {
    if (this.currentFlowStep) {
      if (this.currentFlowStep >= 2) {
        const prevFormName = this.flow[this.currentFlowStep - 2];
        if (prevFormName) this.activeFormName = prevFormName;
      } else {
        this.Quit();
      }
    } else if (this.completedForms.length > 0) {
      this.activeFormName = this.completedForms.pop();
    } else {
      this.Quit();
    }
    if (window) window.scrollTo(0, 0);
  };

  @action Next = (window) => {
    const handler = this.activeForm.conf.buttonHandler;
    if (handler) {
      this.handlers[handler]();
    } else if (this.currentFlowStep) {
      const nextFormName = this.flow[this.currentFlowStep];
      nextFormName && this.SetActiveFormName(nextFormName);
    } else {
      this.SetActiveFormName(
        this.formStores.get(this.activeFormName).conf.nextForm
      );
    }
    if (window) window.scrollTo(0, 0);
  };

  @action SetFlow = flow => {
    this.flow = flow;
  };

  @action Quit = () => {
    goBack();
  };
}
